export default class User {
  constructor(object) {
    try {
      this.map(object)
    } catch(e) {
      console.warn('Invalid Type: ModelUser')
    }
  }
  map(object) {
    this.nickname = object.nickname
    this.imageUrl = object.imageUrl
  }

}